import { CircularProgress, Fade } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MuiButtonStyled } from './Button.styles';

/** Most used button */
export const Button = ({
  textId,
  children,
  isLoading,
  defaulMessage,
  label,
  disabled,
  variant,
  ...rest
}) => {
  return (
    <MuiButtonStyled
      disableRipple
      disabled={disabled}
      endIcon={
        isLoading && (
          <Fade direction="right" in={isLoading} mountOnEnter unmountOnExit>
            <CircularProgress
              size={14}
              color="primary"
              style={{ marginLeft: 15 }}
            />
          </Fade>
        )
      }
      variant={variant}
      {...rest}
    >
      {!!textId && (
        <FormattedMessage
          id={textId}
          defaultMessage={defaulMessage || textId}
        />
      )}
      {label && label}
      {children}
    </MuiButtonStyled>
  );
};

Button.propTypes = {
  /** child components rendered inside the button */
  children: PropTypes.node,
  /** id of the FormattedMessage */
  textId: PropTypes.string,
  /** loading boolean to control the circular progress rendering */
  isLoading: PropTypes.bool,
  /** defaultMessage prop of FormattedMessage */
  defaulMessage: PropTypes.string,
  /** label presented inside the button */
  label: PropTypes.string,
  /** disabled */
  disabled: PropTypes.bool,
  /** style variant */
  variant: PropTypes.oneOf(['main', 'secondary']),
};
